import { AddressDTO } from "./addressDTO";

export class PropertyOfferDTO{
    public id? : number;
    public propertyId! : string;
    public header? : string;
    public address? : AddressDTO;
    public imageReference? : string;
    public views? : number;
    public auctionId? : number;
    public auctionType? : number;
    public auctionStatus! : number;
    public auctionEnding? : string;
    public currentPrice? : number;
    public currentHighBid? : number;
    public currentOffer? : number;
    public highBidder : boolean =false ;
    public documentIdList? : DocumentIdDTO[];

    constructor(){
    }

}

export class DocumentIdDTO{
    public id! : number;
    public added! : string;
}